export var enumLabelsAsOptions = function (enumLabels) {
    return Object.entries(enumLabels).map(function (_a) {
        var value = _a[0], label = _a[1];
        return ({
            value: value,
            label: label,
        });
    });
};
